'use strict';

exports.__esModule = true;
exports.reviewCarousel = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _reviewCarousel = require('../actions/review-carousel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GET_REVIEWS_RECEIVED = _reviewCarousel.GET_REVIEWS + '_RECEIVED';
var GET_SPECIALIST_IMAGE_RECEIVED = _reviewCarousel.GET_SPECIALIST_IMAGE + '_RECEIVED';

var INITIAL_STATE = { reviews: [] };

var reviewCarousel = exports.reviewCarousel = function reviewCarousel(state, action) {
	switch (action.type) {
		case GET_REVIEWS_RECEIVED:
			{
				var reviewsResponse = action.response.reviews.slice(0, 6); //eslint-disable-line
				var carouselReviews = [];
				reviewsResponse.forEach(function (review) {
					carouselReviews.push({
						number_of_stars: review.aggregate_score,
						review: review.review.body,
						specialist: review.specialist || review.practice
					});
				});
				return (0, _assign2.default)({}, state, { reviews: carouselReviews });
			}
		case GET_SPECIALIST_IMAGE_RECEIVED:
			{
				var _reviews = (0, _assign2.default)([], state.reviews);
				for (var i = 0; i < _reviews.length; i++) {
					if (_reviews[i].specialist.id === action.response.specialist.id) {
						_reviews[i].specialist.profile_image = action.response.specialist.attributes.profile_featured_image + '_lg.jpg';
						_reviews[i].specialist.name = action.response.specialist.name;
						_reviews[i].specialist.specialty = action.response.specialist.specialties[0].name;
					}
				}
				return (0, _assign2.default)({}, state, _reviews);
			}
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/home-page/lib/reducers/review-carousel.js